import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import * as cartActions from '../state/shopping-cart/cart-action';
import * as cartSelectors from '../state/shopping-cart/cart-selectors';
import {Action,Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ClearCartComponent} from './actions/clear-cart.component';
import {UrlService} from '@app/services/url.service';
import {Router} from '@angular/router';
import {SeoContent} from '@app/marketplace/seo-content/seo-content';
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';
import { INotification } from '@app/marketplace/core/models/response.model';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.css']
})
export class ShoppingCartComponent extends SeoContent implements OnInit {
  isLoading$: Observable<any>;
  shoppingCart$: Observable<any>;
  message$: Observable<string>;
  notification$: Observable<INotification>;
  success$: Observable<boolean>;
  closeAction:Action;
  constructor(private store: Store<any>,
              private modalService: NgbModal,
              private urlService: UrlService,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId) {
    super(null, null, null, router);
    this.message$ = this.store.select(cartSelectors.selectMessage);
    this.success$ = this.store.select(cartSelectors.selectSuccess);
    this.closeAction=cartActions.CloseErrorMessage();
  }
  ngOnInit(): void {
    this.title = 'Cubatel Market | Compras a Cuba online';
    this.description = 'Realiza tus compras para Cuba online desde cualquier lugar del mundo. Entregas a domicilio en toda la Isla. ¡Aprovecha la oportunidad de enviar miles de productos hasta la puerta de tu casa en Cuba!';
    this.keywords = 'comprar online en cuba, compras para cuba online';
    this.h1 = 'Carrito de Compras';
    window.scroll(0, 0);
    this.shoppingCart$ = this.store.select(cartSelectors.selectData);
    this.isLoading$ = this.store.select(cartSelectors.selectIsLoading);
    this.notification$= this.store.select(cartSelectors.selectNotification);
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }

  public pushToCart(product: any) {
    this.store.dispatch(cartActions.PushToCart({product,viewType:ViewTypeEnum.ShoppingCart}));
  }

  public pullFromCart(product: any) {
    this.store.dispatch(cartActions.PullFromCart({product,viewType:ViewTypeEnum.ShoppingCart}));
  }

  public deleteFromCart(product: any) {
    this.store.dispatch(cartActions.DeleteFromCart({product,viewType:ViewTypeEnum.ShoppingCart}));
  }

  public clearCart(): void {
    const modalRef = this.modalService.open(ClearCartComponent, {size: 'md'});
    modalRef.result.then(() => {
    });
  }
}
